import { errorTracker } from './errorTracking';

export type EventKey =
  | 'transaction_created'
  | 'transaction_updated'
  | 'transaction_deleted'
  | 'transaction_split'
  | 'transaction_unsplit_transaction'
  | 'recurring_transaction_created'
  | 'recurring_transaction_deleted'
  | 'recurring_transaction_toggled'
  | 'main_income_toggled'
  | 'budget_created'
  | 'budget_deleted'
  | 'goal_updated'
  | 'receipt_uploaded'
  | 'receipt_analyzed'
  | 'csv_imported'
  | 'account_created'
  | 'account_renamed'
  | 'bank_connection_started'
  | 'bank_connection_disconnected'
  | 'family_member_invited'
  | 'family_member_removed'
  | 'default_currency_changed'
  | 'credit_card_payment_marked';

const event = (key: EventKey, properties?: Record<string, string | number | boolean>) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production') {
    console.log('LOG_EVENT:', key);
  }
  try {
    if (typeof window !== 'undefined') {
      import('posthog-js')
        .then(({ default: posthog }) => {
          posthog.capture(key, {
            platform: 'web',
            environment: process.env.NEXT_PUBLIC_VERCEL_ENV || 'local',
            ...(properties ?? {}),
          });
        })
        .catch((err) => {
          errorTracker.captureException(err as Error, {
            tags: {
              service: 'analytics',
              event: key,
            },
            extra: {
              context: 'analytics import/capture',
              properties,
            },
          });
        });
    }
  } catch (error) {
    // Use error tracker to capture the error in both Sentry and PostHog
    errorTracker.captureException(error as Error, {
      tags: {
        service: 'analytics',
        event: key,
      },
      extra: {
        properties,
      },
    });
  }
};

export default {
  event,
};
